import { EarthModel } from "./EarthModel";
import { IoMdArrowRoundDown } from "react-icons/io";





function Main(){
    return (
        <main id="main">
            <div className="container">
              <div className="hero-earth">
                <EarthModel />
              </div>
              <div className="hero-content">
                <p className="hero-kicker">Computer Science Engineer Student</p>
                <h1>Tadj El Islam Zerroug</h1>
                <h3>Building AI-powered and full-stack solutions</h3>
                <p className="hero-copy">
                  ESI Algiers student focused on machine learning, agentic AI systems,
                  and practical web products with clean user experiences.
                </p>
                <a href="#projects" className="hero-cta">Explore my work <IoMdArrowRoundDown /></a>
              </div>
            </div>
        </main>
    )
}

export default Main ; 